
type TechPublisherBatchType = 'default' | 'simplified'

export function createTechPublisherScenario(type: TechPublisherBatchType, data: any) {

  const baseAudit = {
    userDefinedNetwork: 'Own',
    link: data.link,
    cookieName: data.cookieName,
    cookieType: data.cookieType,
    customAni: data.customAni,
    customMasterTag: data.customNetwork,
    countryCode: data.countryCode
  }

  const baseTechAudit = {
    cookieName:           data.techCookieName,
    cookieType:           '3',
    customMasterTag:      data.techMasterTag,
  }

  // standard
  const standard = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > consent > Refresh',
    tagA:                 'Affiliate > consent > Refresh',
  }

  // skip consent
  const skipConsent = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > skip > Refresh',
    tagA:                 'Affiliate > skip > Refresh', 
    skipConsent:          true,
  }

  // refresh affiliate link
  const refreshAffiliate = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > consent > affiliate',
    tagA:                 'Affiliate > consent > affiliate',
    postAlpURL:           data.link,
  }

  // homepage => skip => affiliate link refresh
  const homepageSkipAffiliate = {
    ...baseAudit,
    userDefinedMerchant:  'Start > skip > affiliate',
    tagA:                 'Start > skip > affiliate',
    link:                 data.advertiserHome,
    skipConsent:          true,
    postAlpURL:           data.link,
  }

  // homepage => consent => affiliate link refresh
  const homepageConsentAffiliate = {
    ...baseAudit,
    userDefinedMerchant:  'Start > consent > affiliate',
    tagA:                 'Start > consent > affiliate',
    link:                 data.advertiserHome,
    postAlpURL:           data.link,
  }

  // affiliate skip affiliate
  const affiliateSkipAffiliate = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > skip > affiliate',
    tagA:                 'Affiliate > skip > affiliate',
    link:                 data.link,
    skipConsent:          true,
    postAlpURL:           data.link,
  }

  // affiliate => consent with tech cookie
  const affiliateConsentTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Affiliate > consent (TP)',
    tagA:                 'Affiliate > consent (TP)',
    link:                 data.link,
  }

  // affiliate => skip consent with tech cookie
  const affiliateSkipTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Affiliate > skip (TP)',
    tagA:                 'Affiliate > skip (TP)',
    link:                 data.link,
    skipConsent:          true,
  }

  // affiliate => consent => affiliate link refresh with tech cookie
  const affiliateConsentAffiliateRefreshTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Affiliate > consent > affiliate (TP)',
    tagA:                 'Affiliate > consent > affiliate (TP)',
    link:                 data.link,
    postAlpURL:           data.link,
  }

  // homepage skip affiliate with tech cookie
  const homepageSkipAffiliateTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Start > skip > affiliate (TP)',
    tagA:                 'Start > skip > affiliate (TP)',
    link:                 data.advertiserHome,
    skipConsent:          true,
    postAlpURL:           data.link,
  }

  // homepage consent affiliate with tech cookie
  const homepageConsentAffiliateTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Start > consent > affiliate (TP)',
    tagA:                 'Start > consent > affiliate (TP)',
    link:                 data.advertiserHome,
    postAlpURL:           data.link,
  }

  // affiliate => skip consent => affiliate with tech cookie
  const affiliateSkipAffiliateTechCookie = {
    ...baseAudit,
    ...baseTechAudit,
    userDefinedMerchant:  'Affiliate > skip > affiliate (TP)',
    tagA:                 'Affiliate > skip > affiliate (TP)',
    link:                 data.link,
    skipConsent:          true,
    postAlpURL:           data.link,
  }

  // Generate the correct scenario

  function createScenario(batchLinks: any[]): any[] {
    return batchLinks.map((link, i) => ({
      ...link,
      userDefinedMerchant: `${i + 1}. ${link.userDefinedMerchant}`,
    }))
  }

  if (type === 'default') {
    return createScenario([
      standard,
      skipConsent,
      refreshAffiliate,
      homepageSkipAffiliate,
      homepageConsentAffiliate,
      affiliateSkipAffiliate,
      affiliateConsentTechCookie,
      affiliateSkipTechCookie,
      affiliateConsentAffiliateRefreshTechCookie,
      homepageSkipAffiliateTechCookie,
      homepageConsentAffiliateTechCookie,
      affiliateSkipAffiliateTechCookie,
    ])
  }
  else if (type === 'simplified') {
    return createScenario([
      skipConsent,
      standard,
      homepageSkipAffiliate,
      homepageConsentAffiliate,
      homepageSkipAffiliateTechCookie,
      homepageConsentAffiliateTechCookie,
    ])
  }

  throw new Error(`Unexpected tech publisher batch type: ${type}`)
}
